import clsx from "clsx";

type LoaderProps = {
	className?: string;
};

export default function Loader({ className }: LoaderProps) {
	return (
		<div className={clsx("flex items-center justify-center", className)}>
			<div className="relative">
				<div className="loader"></div>
			</div>
		</div>
	);
}
